//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Whether this viewport presents floating panels at all.
 *
 * The header offers panel launchers only from `sm` up; below that, plugin
 * surfaces open as drawer-launched modals and there is no rail to park a
 * panel back into. The registry asks this before putting a panel on screen
 * with no gesture behind it -- a session restore, a preload -- and holds
 * back the panels whose spec declares a desktop-only launcher, which would
 * otherwise be mounted with no way for the user to reach or dismiss them.
 * Chat declares none: its launcher pill renders on every viewport.
 *
 * Live, not read once: a window dragged from phone width to desktop width
 * re-renders the provider, so a restore held back at mount happens when the
 * viewport can honor it.
 */
export const useFloatingPanelViewport = (): boolean => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('sm'));
};
